import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { EXPORT_API_REQUEST_URL } from '../../../common/apiConfig';
import {
  REPORTS_EXPORT_SC_IN_ACTION_CUSTOMER_REPORT_BEGIN,
  REPORTS_EXPORT_SC_IN_ACTION_CUSTOMER_REPORT_SUCCESS,
  REPORTS_EXPORT_SC_IN_ACTION_CUSTOMER_REPORT_FAILURE,
  REPORTS_EXPORT_SC_IN_ACTION_CUSTOMER_REPORT_DISMISS_ERROR,
} from './constants';

export function exportScInActionCustomerReport(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: REPORTS_EXPORT_SC_IN_ACTION_CUSTOMER_REPORT_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.post(`${EXPORT_API_REQUEST_URL}/exportScCustomerInfo`, args, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: REPORTS_EXPORT_SC_IN_ACTION_CUSTOMER_REPORT_SUCCESS,
            data: res.data.data,
          });
          resolve(res.data.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: REPORTS_EXPORT_SC_IN_ACTION_CUSTOMER_REPORT_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissExportScInActionCustomerReportError() {
  return {
    type: REPORTS_EXPORT_SC_IN_ACTION_CUSTOMER_REPORT_DISMISS_ERROR,
  };
}

export function useExportScInActionCustomerReport() {
  const dispatch = useDispatch();

  const { exportScInActionCustomerReportPending, exportScInActionCustomerReportError } = useSelector(
    state => ({
      exportScInActionCustomerReportPending: state.reports.exportScInActionCustomerReportPending,
      exportScInActionCustomerReportError: state.reports.exportScInActionCustomerReportError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(exportScInActionCustomerReport(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissExportScInActionCustomerReportError());
  }, [dispatch]);

  return {
    exportScInActionCustomerReport: boundAction,
    exportScInActionCustomerReportPending,
    exportScInActionCustomerReportError,
    dismissExportScInActionCustomerReportError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case REPORTS_EXPORT_SC_IN_ACTION_CUSTOMER_REPORT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        exportScInActionCustomerReportPending: true,
        exportScInActionCustomerReportError: null,
      };

    case REPORTS_EXPORT_SC_IN_ACTION_CUSTOMER_REPORT_SUCCESS:
      // The request is success
      return {
        ...state,
        exportScInActionCustomerReportPending: false,
        exportScInActionCustomerReportError: null,
      };

    case REPORTS_EXPORT_SC_IN_ACTION_CUSTOMER_REPORT_FAILURE:
      // The request is failed
      return {
        ...state,
        exportScInActionCustomerReportPending: false,
        exportScInActionCustomerReportError: action.data.error,
      };

    case REPORTS_EXPORT_SC_IN_ACTION_CUSTOMER_REPORT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        exportScInActionCustomerReportError: null,
      };

    default:
      return state;
  }
}
